<template>
  <baidu-map id="mapContainer" ref="mapContainer" class="map_device" center="上海" :scroll-wheel-zoom="map.scrollWheelZoom"
    :dragging="map.dragging" :double-click-zoom="map.dbClickZoom" @click="mapClick" @mousemove="mapMouseMove"
    @rightclick="mapRightClick" :mapStyle="map.mapStyle" @ready="ready">
    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
    <bm-control :offset="{width:10,height:10}">
      <select-device-status @change="changeDeviceStatus"></select-device-status>
    </bm-control>
    <bm-control :offset="{width:140,height:10}">
      <el-button-group>
        <el-button title="画圆" icon="iconfont icon-xuanzeyuanquanxuanzhong" @click="drawGeometry('circle')"></el-button>
        <el-button title="画矩形" icon="iconfont icon-kuangxuan" @click="drawGeometry('rectangle')"></el-button>
        <el-button title="画多边形" icon="iconfont icon-duobianxing" @click="drawGeometry('polygon')"></el-button>
        <el-button title="拖动地图" icon="iconfont icon-shou" @click="hander"></el-button>
      </el-button-group>
    </bm-control>
    <bm-control :offset="{width:380,height:10}">
      <el-select v-model="district" placeholder="按行政区选择" @change="handleDistricChange">
        <el-option v-for="item in districtList" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </bm-control>
    <bm-control v-show="selectedTable.show" :offset="{width:140,height:60}">
      <el-card>
        <div @mouseover="map.scrollWheelZoom=false;" @mouseout="map.scrollWheelZoom=true;">
          <el-table :data="selected" style="width:570px;margin-bottom:15px;" height="250px" border size="mini"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="35"></el-table-column>
            <el-table-column prop="log_id" label="编号" width="130">
            </el-table-column>
            <el-table-column label="地址">
              <template slot-scope="scope">{{scope.row.province || scope.row.city || scope.row.county ||
                scope.row.district || scope.row.street || scope.row.address ? `
                ${scope.row.province?scope.row.province:""} ${scope.row.city?scope.row.city:""}
                ${scope.row.county?scope.row.county:""} ${scope.row.district?scope.row.district:""}
                ${scope.row.street?scope.row.street:""} ${scope.row.address?scope.row.address:""}`:"无数据"}}
              </template>
            </el-table-column>
            <el-table-column label="周期任务" width="70">
              <template slot-scope="scope">
                {{scope.row.task_id?scope.row.task_id:"未配置"}}
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="50">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="locateDvice({lng: scope.row.lon, lat: scope.row.lat})">位置</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button-group>
            <el-button type="primary" plain size="small" @click="scan(idsOfDevices)">扫台</el-button>
            <el-button type="primary" plain size="small" @click="record(idsOfDevices)">录音</el-button>
            <el-button type="primary" plain size="small" @click="reboot(idsOfDevices)">重启</el-button>
            <el-button type="primary" plain size="small" @click="setTask(idsOfDevices)">配置任务</el-button>
          </el-button-group>
          <el-button style="float:right;" @click="selectedTable.show=false;" type="info" plain size="small">关闭</el-button>
        </div>
      </el-card>
    </bm-control>
    <bm-marker v-for="device in markers" @click="showInfoWindow(device)" :icon="icons[device.status]" :key="device.phy_id"
      :title="device.log_id" :position="{lng: device.lon, lat: device.lat}">
    </bm-marker>
    <bm-marker v-if="pointer.show" animation="BMAP_ANIMATION_BOUNCE" :position="pointer.position" :icon="pointer.icon"></bm-marker>
    <bm-info-window title="设备信息" :show="infowindow.show" :position="infowindow.position" :width="430" @open="infowindow.show=true;"
      @close="infowindow.show=false;">
      <device-detail :lgid="infowindow.device_lgid"></device-detail>
      <el-button-group style="margin-top:15px;margin-left:10px;">
        <el-button type="info" plain size="small" @click="scan([infowindow.device_lgid])">扫台</el-button>
        <el-button type="info" plain size="small" @click="record([infowindow.device_lgid])">录音</el-button>
        <el-button type="info" plain size="small" @click="reboot([infowindow.device_lgid])">重启</el-button>
        <el-button type="info" plain size="small" @click="setTask([infowindow.device_lgid])">配置任务</el-button>
      </el-button-group>
    </bm-info-window>
    <bm-circle v-if="drawing.drawingType=='circle'" :center="drawing.circlePath.center" :radius="drawing.circlePath.radius"
      :stroke-color="drawing.styleOptions.strokeColor" :fill-color="drawing.styleOptions.fillColor" :stroke-opacity="drawing.styleOptions.strokeOpacity"
      :fill-opacity="drawing.styleOptions.fillOpacity" :stroke-weight="drawing.styleOptions.strokeWeight" :stroke-style="drawing.styleOptions.strokeStyle"
      :editing="drawing.editing"></bm-circle>
    <bm-polygon v-else-if="drawing.drawingType=='polygon' || drawing.drawingType=='rectangle'" :path="drawing.polygonPath"
      :stroke-color="drawing.styleOptions.strokeColor" :fill-color="drawing.styleOptions.fillColor" :stroke-opacity="drawing.styleOptions.strokeOpacity"
      :fill-opacity="drawing.styleOptions.fillOpacity" :stroke-weight="drawing.styleOptions.strokeWeight" :stroke-style="drawing.styleOptions.strokeStyle"
      :editing="drawing.editing"></bm-polygon>
  </baidu-map>
</template>
<script>
  import SelectDeviceStatus from "@/components/Selectors/DeviceStatus";
  import DeviceDetail from "@/components/Form/DeviceDetail";
  const ER = 6370996.81; // earth radius
  const PI = 3.1415926;
  export default {
    components: {
      SelectDeviceStatus,
      DeviceDetail
    },
    watch: {},
    data() {
      return {
        // 地图容器参数
        map: {
          mapInterface: null, //BMap类
          mapInstance: null, //map实例
          mapCursorDefault: null,
          scrollWheelZoom: true,
          dragging: true,
          dbClickZoom: false,
          mapStyle: {
            styleJson: [{
              featureType: "highway",
              elementType: "all",
              stylers: {
                weight: "0.1",
                visibility: "on"
              }
            }]
          }
        },
        // 在设备表中点击后，在地图中显示设备位置的 指示标志 参数
        pointer: {
          position: {},
          show: false,
          icon: {
            url: "/image/pointer_down.png",
            size: {
              width: 32,
              height: 32
            },
            opts: {
              anchor: {
                width: 16,
                height: 32
              }
            }
          },
          timeoutHandle: null
        },
        // 框选等的绘制参数
        drawing: {
          isStartPoint: true, // 标识下一个点是起点还是中间点
          isFinished: true, // 标识绘图状态，用于确定mousemove是否响应
          drawingType: "", //默认手形，不做图
          circlePath: {
            center: {
              lng: NaN,
              lat: NaN
            },
            radius: 0
          },
          polygonPath: [],
          polygonPointCnt: 0,
          styleOptions: {
            strokeColor: "#87CEEB", //边线颜色。
            fillColor: "#87CEEB", //填充颜色。当参数为空时，圆形将没有填充效果。
            strokeWeight: 3, //边线的宽度，以像素为单位。
            strokeOpacity: 0.6, //边线透明度，取值范围0 - 1。
            fillOpacity: 0.4, //填充的透明度，取值范围0 - 1。
            strokeStyle: "solid" //边线的样式，solid或dashed。
          },
          editing: false
        },
        icons: {
          "-1": {
            url: "/image/error.png",
            size: {
              width: 23,
              height: 23
            },
            opts: {
              anchor: {
                width: 11,
                height: 23
              }
            }
          },
          "0": {
            url: "/image/offline.png",
            size: {
              width: 23,
              height: 23
            },
            opts: {
              anchor: {
                width: 11,
                height: 23
              }
            }
          },
          "1": {
            url: "/image/online.png",
            size: {
              width: 23,
              height: 23
            },
            opts: {
              anchor: {
                width: 11,
                height: 23
              }
            }
          },
          "2": {
            url: "/image/online.png",
            size: {
              width: 23,
              height: 23
            },
            opts: {
              anchor: {
                width: 11,
                height: 23
              }
            }
          },
          "3": {
            url: "/image/online.png",
            size: {
              width: 23,
              height: 23
            },
            opts: {
              anchor: {
                width: 11,
                height: 23
              }
            }
          }
        },
        // 地图窗体 用于显示设备信息
        infowindow: {
          show: false,
          position: {
            lng: 116.404,
            lat: 39.915
          },
          device_lgid: ""
        },
        selectedTable: {
          show: false
        },
        devices: [], //所有的设备
        markers: [], //地图上图标显示的设备
        selected: [], //通过图形或者行政区选择出的设备(通过table显示)
        idsOfDevices: [], //需要下发指令的设备id列表
        districtList: [
          "全部",
          "黄浦区",
          "徐汇区",
          "长宁区",
          "静安区",
          "普陀区",
          "虹口区",
          "杨浦区",
          "闵行区",
          "宝山区",
          "嘉定区",
          "浦东新区",
          "金山区",
          "松江区",
          "青浦区",
          "奉贤区",
          "崇明区",
          "其它"
        ],
        district: null
      };
    },
    created() {
      this.searchDevices();
    },
    mounted() {},
    methods: {
      handleDistricChange() {
        if (this.district) {
          this.selected = [];
          if (this.district == "全部") {
            this.selected = this.markers;
          } else if (this.district == "其它") {
            this.selected = [];
            for (let i = 0; i < this.markers.length; i++) {
              if (!this.districtList.in_array(this.markers[i].district)) {
                this.selected.push(this.markers[i]);
              }
            }
          } else {
            for (let i = 0; i < this.markers.length; i++) {
              if (
                this.markers[i].district &&
                this.markers[i].district.trim() == this.district
              ) {
                this.selected.push(this.markers[i]);
              }
            }
          }
          if (this.selected.length > 0) {
            this.selectedTable.show = true;
          }
        }
      },
      ready(params) {
        this.map.mapInterface = params.BMap;
        this.map.mapInstance = params.map;
        this.map.mapCursorDefault = params.map.getDefaultCursor();
      },
      handleSelectionChange(selection) {
        this.idsOfDevices = [];
        selection.map(item => this.idsOfDevices.push(item.log_id));
      },
      // 在地图上指示设备位置
      locateDvice(position) {
        clearTimeout(this.pointer.timeoutHandle);
        this.pointer.position = position;
        this.pointer.show = true;
        this.pointer.timeoutHandle = setTimeout(() => {
          this.pointer.show = false;
        }, 1200);
      },
      getTagType(text) {
        switch (text) {
          case "空闲":
            return "success";
          case "离线":
            return "info";
          default:
            return "warning";
        }
      },
      // 点击地图 控制绘图
      mapClick(e) {
        const drawType = this.drawing.drawingType;
        if (drawType == "") {
          return;
        }
        if (this.drawing.isStartPoint) {
          if (drawType == "circle") {
            this.drawing.circlePath.center = e.point;
            this.drawing.circlePath.radius = 0;
          } else if (drawType == "rectangle") {
            this.drawing.polygonPath = [e.point];
          } else if (drawType == "polygon") {
            this.drawing.polygonPath = [e.point];
            this.drawing.polygonPointCnt = 1;
          }
          this.drawing.isStartPoint = false;
          this.drawing.isFinished = false;
        } else {
          if (drawType == "polygon") {
            if (this.drawing.polygonPointCnt == this.drawing.polygonPath.length) {
              this.drawing.polygonPath.push(e.point);
            }
            this.drawing.polygonPointCnt++;
          }
        }
      },
      // 实现动态绘图效果
      mapMouseMove(e) {
        if (this.drawing.isFinished) {
          return;
        }
        if (this.drawing.drawingType == "circle") {
          this.drawing.circlePath.radius = e.target.getDistance(
            this.drawing.circlePath.center,
            e.point
          );
        } else if (this.drawing.drawingType == "rectangle") {
          const TL = this.drawing.polygonPath[0]; // top left
          const BR = e.point; // bottom right
          this.drawing.polygonPath = [
            TL,
            {
              lng: BR.lng,
              lat: TL.lat
            },
            BR,
            {
              lng: TL.lng,
              lat: BR.lat
            }
          ];
        } else if (this.drawing.drawingType == "polygon") {
          if (this.drawing.polygonPointCnt == this.drawing.polygonPath.length) {
            this.drawing.polygonPath.push(e.point);
          } else {
            this.$set(
              this.drawing.polygonPath,
              this.drawing.polygonPath.length - 1,
              e.point
            );
          }
        }
      },
      // 右键地图 控制绘图
      mapRightClick(e) {
        if (this.drawing.isFinished) {
          return;
        }
        if (this.drawing.drawingType == "circle") {
          this.drawing.circlePath.radius = e.target.getDistance(
            this.drawing.circlePath.center,
            e.point
          );
          this.drawing.isStartPoint = true;
          this.drawing.isFinished = true;
          this.selectByGeometry();
        } else if (this.drawing.drawingType == "rectangle") {
          const TL = this.drawing.polygonPath[0]; // top left
          const BR = e.point; // bottom right
          this.drawing.polygonPath = [
            TL,
            {
              lng: BR.lng,
              lat: TL.lat
            },
            BR,
            {
              lng: TL.lng,
              lat: BR.lat
            }
          ];
          this.drawing.isStartPoint = true;
          this.drawing.isFinished = true;
          this.selectByGeometry();
        } else if (this.drawing.drawingType == "polygon") {
          this.drawing.isStartPoint = true;
          this.drawing.isFinished = true;
          this.selectByGeometry();
        }
      },
      // 设置绘图类型 并初始化参数
      drawGeometry(drawType) {
        if (this.drawing.drawingType == drawType) {
          return;
        }
        //设置地图指针样式
        this.map.mapInstance.setDefaultCursor("crosshair");
        this.drawing.drawingType = drawType;
        // 按类型初始化
        if (drawType == "circle") {
          this.drawing.circlePath.center = {
            lng: NaN,
            lat: NaN
          };
          this.drawing.radius = 0;
        } else if (drawType == "rectangle") {
          this.drawing.polygonPath = [];
        } else if (drawType == "polygon") {
          this.drawing.polygonPath = [];
          this.drawing.polygonPointCnt = 0;
        }
        this.drawing.isStartPoint = true; //下一个点为绘图开始的第一个点
        this.drawing.isFinished = true; // 初始为true，这样避免在 click 之前响应MouseMove和dbclick事件
      },
      hander() {
        if (this.drawing.drawingType == "") {
          return;
        }
        //设置地图指针样式
        this.map.mapInstance.setDefaultCursor(this.map.mapCursorDefault);
        this.drawing.drawingType = "";
      },
      // 选区绘制完成后，选择出选区内的设备点
      selectByGeometry() {
        this.selected = [];
        for (let index = 0; index < this.markers.length; index++) {
          const element = this.markers[index];
          const pnt = {
            lng: element.lon,
            lat: element.lat
          };
          let flag;
          switch (this.drawing.drawingType) {
            case "circle":
              flag = this.isPointInCircle(pnt, this.drawing.circlePath);
              break;
            case "rectangle":
              flag = this.isPointInRect(pnt, this.drawing.polygonPath);
              break;
            default:
              flag = this.isPointInPolygon(pnt, this.drawing.polygonPath);
              break;
          }
          if (flag) {
            this.selected.push(element);
          }
        }
        if (this.selected.length > 0) {
          this.selectedTable.show = true;
        } else {
          this.$message({
            message: "未选中任何设备",
            type: "warning"
          });
        }
      },
      // 显示设备信息
      showInfoWindow(device) {
        this.infowindow.show = true;
        this.infowindow.position = {
          lng: device.lon,
          lat: device.lat
        };
        this.infowindow.device_lgid = device.log_id;
      },
      changeDeviceStatus(value) {
        if (value.length == 0) {
          this.markers = this.devices;
        } else {
          let markers = [];
          for (var i = 0; i < this.devices.length; i++) {
            var device = this.devices[i];
            if (value.in_array(device.status * 1)) markers.push(device);
          }
          this.markers = markers;
        }
      },
      searchDevices() {
        this.$getJSON("/terminal/s_devicelst_all", {}).then(res => {
          this.devices = res.data;
          this.markers = this.devices;
        });
      },
      // 按球面公式计算距离
      getDistance(p1, p2) {
        let p1x = this.degreeToRad(p1.lng),
          p1y = this.degreeToRad(p1.lat),
          p2x = this.degreeToRad(p2.lng),
          p2y = this.degreeToRad(p2.lat);
        return (
          ER *
          Math.acos(
            Math.sin(p1y) * Math.sin(p2y) +
            Math.cos(p1y) * Math.cos(p2y) * Math.cos(p2x - p1x)
          )
        );
      },
      degreeToRad(degree) {
        return Math.PI * degree / 180;
      },
      radToDegree(radian) {
        return 180 * radian / Math.PI;
      },
      isPointInCircle(pnt, circlePath) {
        let distance = this.getDistance(pnt, circlePath.center);
        return distance <= circlePath.radius;
      },
      isPointInRect(pnt, rectPath) {
        let TL = rectPath[0], // topleft corner
          BR = rectPath.length == 2 ? rectPath[1] : rectPath[2]; // bottomright corner
        return (
          (pnt.lng - TL.lng) * (pnt.lng - BR.lng) <= 0 &&
          (pnt.lat - TL.lat) * (pnt.lat - BR.lat) <= 0
        );
      },
      // 获取平面几何图形的外框（左上、右下顶点）
      getBounds(path) {
        let arr_x = path.map(function (value, index, arr) {
          return value.lng;
        });
        let arr_y = path.map(function (value, index, arr) {
          return value.lat;
        });
        return [{
            lng: arr_x.min(),
            lat: arr_y.max()
          },
          {
            lng: arr_x.max(),
            lat: arr_y.min()
          }
        ];
      },
      // 判断点是否在多边形内
      isPointInPolygon(pnt, polygonPath) {
        if (!this.isPointInRect(pnt, this.getBounds(polygonPath))) {
          return false;
        }
        let len = polygonPath.length;
        let cnt = 0;
        let tolerance = 2e-10;
        let pStart, pEnd; // 多边形边的起点、终点
        pStart = polygonPath[0];
        for (let i = 1; i <= len; ++i) {
          if (pnt.lng == pStart.lng && pnt.lat == pStart.lat) {
            return true; // 与起点重合，说明在多边形上
          }
          pEnd = polygonPath[i % len]; //多边形最后一条边的终点即第一条边的起点
          if (
            pnt.lat < Math.min(pStart.lat, pEnd.lat) ||
            pnt.lat > Math.max(pStart.lat, pEnd.lat)
          ) {
            pStart = pEnd;
            continue; // 水平射线与边不相交，则直接跳到下一条边
          }
          if (
            pnt.lat > Math.min(pStart.lat, pEnd.lat) &&
            pnt.lat < Math.max(pStart.lat, pEnd.lat)
          ) {
            if (pnt.lng <= Math.max(pStart.lng, pEnd.lng)) {
              // 边水平
              if (
                pStart.lat == pEnd.lat &&
                pnt.lng >= Math.min(pStart.lng, pEnd.lng)
              ) {
                return true;
              }
              // 边垂直
              if (pStart.lng == pEnd.lng) {
                if (pStart.lng == pnt.lng) {
                  return true;
                } else {
                  ++cnt;
                }
              } else {
                let r =
                  (pnt.lat - pStart.lat) *
                  (pEnd.lng - pStart.lng) /
                  (pEnd.lat - pStart.lat) +
                  pStart.lng;
                if (Math.abs(pnt.lng - r) < tolerance) {
                  return true;
                }
                if (pnt.lng < r) {
                  ++cnt;
                }
              }
            }
          } else {
            // 射线经过边的终点
            if (pnt.lat == pEnd.lat && pnt.lng <= pEnd.lng) {
              let pNext = polygonPath[(i + 1) % len];
              if (
                pnt.lat >= Math.min(pStart.lat, pNext.lat) &&
                pnt.lat <= Math.max(pStart.lat, pNext.lat)
              ) {
                ++cnt; // 当前边与下一条边在射线的异侧
              } else {
                cnt += 2; // 当前边与下一条边在射线的同侧
              }
            }
          }
          pStart = pEnd;
        }
        if (cnt % 2 == 0) {
          return false;
        } else {
          return true;
        }
      },
      async setTask(deviceIdList) {
        if (deviceIdList.length == 0) {
          this.$message({
            message: "请选择设备",
            type: "warning"
          });
          return;
        }

        let taskInfo = await this.$prompt("请输入周期任务号", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[1-9]\d*$/,
          inputErrorMessage: "任务号格式不正确"
        }).catch(() => {});
        if (taskInfo === undefined) {
          return;
        }

        let task_id = taskInfo.value;
        let noTask = this.getDeviceOfNoTask(deviceIdList);
        let msg = `设备 ${deviceIdList.join(",")} 的周期任务将被配置为${task_id}`;
        if (noTask.length > 0) {
          msg = `${msg}，其中 ${noTask.join(
          ","
        )} 在设置成功后将被重启以使用新的配置`;
        }
        msg = `${msg}，是否继续？`;
        let confirmInfo = await this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).catch(() => {});
        if (confirmInfo === undefined) {
          return;
        }

        this.$getJSON("/terminal/set_periodTask", {
            task_id: task_id,
            device_list: deviceIdList
          })
          .then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {});
      },
      getDeviceOfNoTask(deviceIdList) {
        let rst = [];
        for (let i = 0; i < deviceIdList.length; i++) {
          for (let j = 0; j < this.selected.length; j++) {
            if (this.selected[j].log_id == deviceIdList[i]) {
              if (this.selected[j].task_id == null) {
                rst.push(deviceIdList[i]);
              }
              break;
            }
          }
        }
        return rst;
      },
      async scan(deviceIdList) {
        if (deviceIdList.length == 0) {
          this.$message({
            message: "请选择设备",
            type: "warning"
          });
          return;
        }

        let msg = `此操作将对设备 ${deviceIdList.join(
        ","
      )} 下发扫台任务，是否继续？`;
        let confirmInfo = await this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).catch(() => {});
        if (confirmInfo === undefined) {
          return;
        }

        this.$getJSON("/apicloud/jpush", {
          devices: deviceIdList,
          command: "scan"
        }).then(res => {
          this.$message({
            message: `任务下发成功，即时任务号为 ${res.task_id}`,
            type: "success"
          });
        });
      },
      async record(deviceIdList) {
        if (deviceIdList.length == 0) {
          this.$message({
            message: "请选择设备",
            type: "warning"
          });
          return;
        }

        let freqInfo = await this.$prompt("请输入频率（范围：87-108）", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator: function (value) {
            let f = Number(value);
            if (isNaN(f)) {
              return "请输入数值";
            }
            if (value.match(/^[0-9]+([.]{1}[0-9]{1})?$/) === null) {
              return "频率为整数或者最多一位小数";
            }
            if (f < 87 || f > 108) {
              return "有效频率范围为87-108";
            }
          },
          inputErrorMessage: "频率格式不正确"
        }).catch(() => {});
        if (freqInfo === undefined) {
          return;
        }

        let recordLengthInfo = await this.$prompt(
          "请输入录音时长（秒）",
          "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputPattern: /^[1-9]\d*$/,
            inputErrorMessage: "录音时长应为正整数"
          }
        ).catch(() => {});
        if (recordLengthInfo === undefined) {
          return;
        }
        let recordLength = recordLengthInfo.value;

        let msg = `此操作将对设备 ${deviceIdList.join(
        ","
      )} 下发录音任务（频率：${freq}、录音时长：${recordLength}），是否继续？`;
        let confirmInfo = await this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).catch(() => {});
        if (confirmInfo === undefined) {
          return;
        }

        this.$getJSON("/apicloud/jpush", {
          devices: deviceIdList,
          command: "record",
          extra: {
            freq: freq,
            length: recordLength
          }
        }).then(res => {
          this.$message({
            message: `任务下发成功，即时任务号为 ${res.task_id}`,
            type: "success"
          });
        });
      },
      async reboot(deviceIdList) {
        if (deviceIdList.length == 0) {
          this.$message({
            message: "请选择设备",
            type: "warning"
          });
          return;
        }

        let msg = `此操作将使设备 ${deviceIdList.join(",")} 重启，是否继续？`;
        let confirmInfo = await this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).catch(() => {});
        if (confirmInfo === undefined) {
          return;
        }

        this.$getJSON("/apicloud/jpush", {
          devices: deviceIdList,
          command: "reboot"
        }).then(res => {
          this.$message({
            message: `重启命令下发成功`,
            type: "success"
          });
        });
      }
    }
  };

</script>
<style>
  .map_device {
    width: 100%;
    height: 100%;
  }

  .map_device .anchorBL {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Map.vue